var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-dialog",
    {
      attrs: { "max-width": "500px" },
      on: {
        keydown: function ($event) {
          if (
            !$event.type.indexOf("key") &&
            _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
          )
            return null
          $event.preventDefault()
          return _vm.onenter.apply(null, arguments)
        },
      },
      model: {
        value: _vm.dialog,
        callback: function ($$v) {
          _vm.dialog = $$v
        },
        expression: "dialog",
      },
    },
    [
      _c(
        "v-card",
        [
          _c(
            "v-card-title",
            [
              _c("span", { staticClass: "headline" }, [
                _vm._v("Swamp (" + _vm._s(this.rules.name) + ")"),
              ]),
              _c("v-spacer"),
              _c("r-authorize", {
                attrs: {
                  master: _vm.masterAccess,
                  locked: _vm.model.locked,
                  enabled: _vm.model.enabled,
                },
                on: {
                  "update:locked": function ($event) {
                    return _vm.$set(_vm.model, "locked", $event)
                  },
                  "update:enabled": function ($event) {
                    return _vm.$set(_vm.model, "enabled", $event)
                  },
                },
              }),
            ],
            1
          ),
          _c(
            "v-card-text",
            [
              _c(
                "v-col",
                { attrs: { cols: "4", sm: "2", md: "2" } },
                [
                  _c(
                    "v-btn",
                    {
                      staticClass: "mr-2",
                      attrs: { small: "" },
                      on: {
                        click: function ($event) {
                          return _vm.showPreview()
                        },
                      },
                    },
                    [_vm._v("View JSON")]
                  ),
                ],
                1
              ),
              _c(
                "v-row",
                { attrs: { dense: "" } },
                [
                  _c(
                    "v-col",
                    { attrs: { cols: "12", md: "2", sm: "2" } },
                    [
                      _c("v-text-field", {
                        attrs: { label: "ID:", "hide-details": "" },
                        model: {
                          value: _vm.model.id,
                          callback: function ($$v) {
                            _vm.$set(_vm.model, "id", _vm._n($$v))
                          },
                          expression: "model.id",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { attrs: { cols: "12", md: "4", sm: "4" } },
                    [
                      _c("v-text-field", {
                        attrs: { label: "Width:", "hide-details": "" },
                        model: {
                          value: _vm.model.width,
                          callback: function ($$v) {
                            _vm.$set(_vm.model, "width", _vm._n($$v))
                          },
                          expression: "model.width",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { attrs: { cols: "12", md: "4", sm: "4" } },
                    [
                      _c("v-text-field", {
                        attrs: { label: "Height:", "hide-details": "" },
                        model: {
                          value: _vm.model.height,
                          callback: function ($$v) {
                            _vm.$set(_vm.model, "height", _vm._n($$v))
                          },
                          expression: "model.height",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { attrs: { cols: "12", md: "2", sm: "2" } },
                    [
                      _c("v-text-field", {
                        attrs: { label: "Path Length:", "hide-details": "" },
                        model: {
                          value: _vm.model.pathLength,
                          callback: function ($$v) {
                            _vm.$set(_vm.model, "pathLength", _vm._n($$v))
                          },
                          expression: "model.pathLength",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "v-row",
                { attrs: { dense: "" } },
                [
                  _c(
                    "v-col",
                    { attrs: { cols: "12", md: "6", sm: "6" } },
                    [
                      _c("r-item-dropdown", {
                        attrs: {
                          label: "Hero Item:",
                          model: _vm.model.heroItem,
                        },
                        on: {
                          "update:model": function ($event) {
                            return _vm.$set(_vm.model, "heroItem", $event)
                          },
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { attrs: { cols: "12", md: "6", sm: "6" } },
                    [
                      _c("r-tile", {
                        attrs: {
                          label: "Finish Hero Teleport Tile",
                          model: _vm.model.heroTeleportTile,
                          "hide-details": "",
                        },
                        on: {
                          "update:model": function ($event) {
                            return _vm.$set(
                              _vm.model,
                              "heroTeleportTile",
                              $event
                            )
                          },
                        },
                      }),
                    ],
                    1
                  ),
                  _c("v-col", { attrs: { cols: "12" } }),
                ],
                1
              ),
              _c(
                "v-row",
                { attrs: { dense: "" } },
                [
                  _c(
                    "v-col",
                    { attrs: { cols: "12", md: "6", sm: "6" } },
                    [
                      _c("r-item-dropdown", {
                        attrs: {
                          label: "Path Item:",
                          model: _vm.model.pathItem,
                        },
                        on: {
                          "update:model": function ($event) {
                            return _vm.$set(_vm.model, "pathItem", $event)
                          },
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { attrs: { cols: "12", md: "6", sm: "6" } },
                    [
                      _c("r-item-dropdown", {
                        attrs: {
                          label: "Block Item:",
                          model: _vm.model.blockItem,
                        },
                        on: {
                          "update:model": function ($event) {
                            return _vm.$set(_vm.model, "blockItem", $event)
                          },
                        },
                      }),
                    ],
                    1
                  ),
                  _c("v-col", { attrs: { cols: "12" } }),
                ],
                1
              ),
              _c(
                "v-row",
                { attrs: { dense: "" } },
                [
                  _c(
                    "v-col",
                    { attrs: { cols: "12", md: "6", sm: "6" } },
                    [
                      _c("r-tile", {
                        attrs: {
                          label: "Bottom Left Tile",
                          model: _vm.model.bottomLeftTile,
                          "hide-details": "",
                        },
                        on: {
                          "update:model": function ($event) {
                            return _vm.$set(_vm.model, "bottomLeftTile", $event)
                          },
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { attrs: { cols: "12", md: "6", sm: "6" } },
                    [
                      _c("r-tile", {
                        attrs: {
                          label: "Top Right Tile",
                          model: _vm.model.topRightTile,
                          "hide-details": "",
                        },
                        on: {
                          "update:model": function ($event) {
                            return _vm.$set(_vm.model, "topRightTile", $event)
                          },
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "v-card-actions",
            [
              _c("v-spacer"),
              _c(
                "v-btn",
                {
                  attrs: { color: "blue darken-1", text: "" },
                  on: { click: _vm.cancel },
                },
                [_vm._v(" Cancel ")]
              ),
              !_vm.lockedAssess || _vm.masterAccess
                ? _c(
                    "v-btn",
                    {
                      attrs: { color: "blue darken-1", text: "" },
                      on: { click: _vm.save },
                    },
                    [_vm._v(" Save ")]
                  )
                : _vm._e(),
            ],
            1
          ),
          _c("r-preview-dialog", { ref: "preview-dialog" }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }